module.exports = __webpack_public_path__ + "img/more2.7a7256e7.png";